import { Dayjs } from 'dayjs';
import { CORE_API_SUFFIX, dataFetch, DIGGER_API_SUFFIX } from '../axios/customAxios';
import closableEnqueueSnackbar from '../components/closableEnqueueSnackbar/closableEnqueueSnackbar';
import React, { useCallback, useEffect, useRef } from 'react';

export const appendQueryParamIfNotEmpty = (params: URLSearchParams, key: string, value: string | number) => {
  if (value !== '' && !Number.isNaN(value as number)) {
    params.append(key, value.toString());
  }
};

export const generateQueryKey = (identifier: string, queryParams: URLSearchParams) => {
  const queryKeyParams = [
    identifier,
    ...queryParams.toString().split('&').filter((param) => param !== ''),
  ];

  return queryKeyParams.join('_');
};

export function formatDate(filterDateRange: Dayjs | null) {
  if (!filterDateRange) {
    return '';
  }

  return filterDateRange.format('YYYY-MM-DD');
}

const triggerDownload = (blobUrl: string, filename: string) => {
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const handleDownloadError = (t: any) => {
  closableEnqueueSnackbar(t('somethingWentWrong'), 'error');
};

export const downloadFile = async (url: string, acceptHeader: string, t: any) => {
  try {
    const response = await dataFetch.get(`${CORE_API_SUFFIX}${url}`, {
      headers: { Accept: acceptHeader },
      responseType: 'blob',
    });

    const contentDisposition = response.headers['content-disposition'] || '';
    const filename = contentDisposition.split('filename=')[1] || 'download';

    const blob = new Blob([response.data], { type: acceptHeader });
    const blobUrl = window.URL.createObjectURL(blob);

    triggerDownload(blobUrl, filename);

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    handleDownloadError(t);
  }
};

export const downloadDiggerFile = async (url: string, acceptHeader: string, t: any) => {
  try {
    const response = await dataFetch.get(`${DIGGER_API_SUFFIX}${url}`, {
      headers: { Accept: acceptHeader },
      responseType: 'blob',
    });

    const contentDisposition = response.headers['content-disposition'] || '';
    const filename = contentDisposition.split('filename=')[1] || 'download';

    const blob = new Blob([response.data], { type: acceptHeader });
    const blobUrl = window.URL.createObjectURL(blob);

    triggerDownload(blobUrl, filename);

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    handleDownloadError(t);
  }
};
export const useDebounce = (
  callback: (...args: any[]) => void,
  delay: number,
) => {
  const callbackRef = useRef(callback);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const debouncedFn = useCallback((...args: any[]) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = window.setTimeout(() => {
      callbackRef.current(...args);
    }, delay);
  }, [delay]);

  return debouncedFn;
};

